import DocumentsSharedWithMePage from './DocumentsSharedWithMePage';
export default DocumentsSharedWithMePage;